<template>
  <v-container>
    <v-row justify="center">
      <v-flex v-bind="{[`sx${DPI*6} sm${DPI*6} md${DPI*5} lg${DPI*4} xl${DPI*3}`]: true}">
        <v-overlay :value="overlay">
          <v-progress-circular
            :indeterminate="iter"
            size="128"
            :width="15"
            color="secondary lighten-2"
          ></v-progress-circular>
        </v-overlay>
        <PrgBar></PrgBar>
        <v-card class="pt-5 mt-5">
          <v-navigation-drawer fixed v-model="drawer" app class="elevation-9 pt-3">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="overline primary--text">Menu</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <!-- :height="items.length*48+10" -->

            <v-list
              class="pa-0"
              v-for="item in items"
              :key="`menu_` + item.id"
              v-bind:id="`menu_` + item.id"
            >
              <v-list-item :to="item.url" ripple exact v-if="!item.menu">
                <!-- MENIU PUNKTAI -->
                <v-list-item-avatar v-if="!item.menu" @click.stop="mini = `false`">
                  <v-icon size="38" v-if="item.icon">$vuetify.icons.{{item.icon}}</v-icon>
                </v-list-item-avatar>

                <!-- PAVADINIMAS -->
                <v-list-item-content v-if="!item.menu" @click.stop="mini = !mini">
                  <v-list-item-title class="caption">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- SISTEMINIS MENIU arba meniu su submeniu punktai -->

              <v-list-group
                v-if="item.menu"
                prepend-icon="settings"
                :value="shwoSubmenu"
                dense
                sub-group
                class="pa-0"
              >
                <v-list-item slot="activator" active-class class="pa-0">
                  <v-list-item-title class="caption">{{ item.title }}</v-list-item-title>
                </v-list-item>

                <v-list class="pa-0" v-for="MenuItem in item.menu" :key="`submenu_` + MenuItem.id">
                  <v-list-item :to="MenuItem.url" ripple @click="showModal(MenuItem)">
                    <!-- MENIU PUNKTAI -->
                    <v-list-item-avatar>
                      <v-icon size="28" v-if="MenuItem.icon">$vuetify.icons.{{MenuItem.icon}}</v-icon>
                    </v-list-item-avatar>
                    <!-- PAVADINIMAS -->
                    <v-list-item-content>
                      <v-list-item-title class="caption">{{ MenuItem.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-list-group>
            </v-list>
          </v-navigation-drawer>
          <v-app-bar dark color="primary " height="50" :app="fab">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" dark></v-app-bar-nav-icon>
            <!-- <v-toolbar-title class="white--text">Menu</v-toolbar-title> -->

            <v-spacer></v-spacer>
            <v-btn
              v-if="getManualURL() !== null"
              text
              class="pa-1"
              :href="getManualURL()"
              :target="getManualURL()"
            >
              User manual
              <v-icon right class="px-1 ml-1">help_outline</v-icon>
            </v-btn>
            <v-btn icon @click="toDisconnect()" class="pa-1 ml-0">
              <v-icon right class="px-1 ml-0">exit_to_app</v-icon>
            </v-btn>
          </v-app-bar>

          <!-- <v-container   pa-0> -->
          <v-layout column fill-height>
            <!-- fill-height -->
            <v-card flat class="ma-2 pb-5" min-height="500">
              <message></message>

              <modalWindow></modalWindow>
              <statusParams v-if="ifStatusVisible()" :items="getStatusParams()"></statusParams>
              <router-view></router-view>
            </v-card>
          </v-layout>
          <!-- </v-container> -->

          <v-footer dark color="primary pa-0 mt-4" class="font-weight-medium" :app="fab">
            <v-flex text-center xs12>
              Copyright {{ new Date().getFullYear() }}
              <strong>&copy; All rights reserved</strong>
            </v-flex>
            <v-btn
              v-scroll="onScroll"
              v-if="direction"
              color="amber"
              dark
              small
              absolute
              top
              right
              fab
              @click="scrollTo(2000)"
            >
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            <v-btn
              v-scroll="onScroll"
              v-else
              color="amber"
              dark
              small
              absolute
              top
              right
              fab
              @click="scrollTo(0)"
            >
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
          </v-footer>
        </v-card>
      </v-flex>
    </v-row>
  </v-container>
</template>

<script>
import router from "../router";
import { loadGroupsFromDevice, updateStatusParams } from "../main";
import message from "../components/message";
import statusParams from "../components/statusParams";
import modalWindow from "../components/modal";
import PrgBar from "../components/progressBar";

export default {
  name: "mainMenu",
  components: {
    message,
    statusParams,
    modalWindow,
    PrgBar
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      menuMounted: false,
      drawer: false,
      mini: false,
      showErrors: false,
      shwoSubmenu: false,
      fab: false,
      direction: false,
      DPI: 0,
      overlay: false,
      iter: true
    };
  },
  beforeMount: function() {
    this.DPI = window.devicePixelRatio;
    if (this.DPI > 1) {
      this.DPI = 8;
      this.fab = true;
    } else {
      this.DPI = 1;
      this.fab = false;
    }

    loadGroupsFromDevice(this.$route.params.id ? this.$route.params.id : 0);
    setTimeout(this.toMount, 500);
  },
  methods: {
    showModal: function(show) {
      if (show.modal) {
        this.overlay = false;
        this.$store.commit("showConfirm", show);
      }
    },
    toDisconnect: function() {
      this.$store.dispatch("disconnectFromDevice");
    },
    getManualURL: function() {
      var Url = null;
      var deviceName = this.$store.getters.getDeviceName;

      if (deviceName === "MHD001" || deviceName === "MHD002")
        Url = "http://update.terra1.lt/u/mhd001";
      if (deviceName === "MHD003" || deviceName === "MHD004")
        Url = "http://update.terra1.lt/u/mhd003";

      return Url;
    },

    ifStatusVisible: function() {
      return this.$store.getters.getActiveMenu.statusGroups
        ? this.$store.getters.getActiveMenu.statusGroups.length > 0
        : false;
      // alert(this.$store.getters.getActiveMenu)
    },
    getStatusParams: function() {
      var Result = [];
      this.$store.getters.getActiveMenu.statusGroups.forEach(function(grp) {
        // Result.push({title: grp.title, group: true})
        // grp.params.forEach(function (param) {
        //   param.grpId = grp.id
        Result.push(grp);
        // })
      });
      return Result;
    },
    scrollTo: function(Target) {
      this.$vuetify.goTo(Target);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.direction = top < 20;
    }
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 1500);
    },
    $route(to, from) {
      this.overlay = !this.overlay;
    }
  },
  beforeDestroy: function() {
    this.menuMounted = false;
  },
  mounted: function() {
    this.overlay = !this.overlay;
    updateStatusParams();
  }
};
</script>
